module.exports = __webpack_public_path__ + "static/media/stop-card.ada2804e.wav";